import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';

import { AppState } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { AsortGrupyWiersz } from 'api';
import roomImg from 'app/assets/noImage.jpg';
import CONFIG from '../../cfg/config';
import { Card, CardActions, Grid } from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import {AddItem} from '../PanelRightBasket';
import { fontSelect } from '../../fonts';
import theme from 'themes';


type DialogErrorProps = {
  classes?: any,
  page?: any,

  close: () => void,
  openGalery: () => void,
  open: boolean,
  data : AsortGrupyWiersz,
  selected: boolean
}

class DialogError extends React.Component<DialogErrorProps, any> {
  textTheme = fontSelect(this.props.page.fonts, 7, 1) as React.CSSProperties;
  selectedTheme = fontSelect(this.props.page.fonts, 13, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 8, 2) as React.CSSProperties;

  constructor(props: any) {
    super(props, {});
  }
  state = {
  };

  ImgError = (source: any) => {
    source.target.src = roomImg;
    source.onerror = "";
    return true;
    }



  render() {
    const classes = this.props.classes;

    let color = this.textTheme.color 
    if(this.props.selected){
      color = this.selectedTheme.color //theme.palette.primary.main
    }
    

    return (

      <Dialog
        //disableEscapeKeyDown
        maxWidth="sm"
        classes={{paper: classes.paper}}
        open={this.props.open}
        onClose={this.props.close}
        fullWidth               
      >
        {/* <DialogTitle disableTypography>
          <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "0.8928571428571429rem", ...this.textTheme, color: color }}>
            <b>{this.props.data.asort_nazwa}</b>
          </Typography>
          <hr className={classes.hr} />
        </DialogTitle> */}
        <DialogContent style={{padding: "24px 24px 0px"}} >


{/* 
            <img
                className={classes.media}
                onClick={this.props.openGalery}

                title={this.props.data.asort_nazwa}
                src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.data.asort_id}/th_foto.jpg`}
                onError={this.ImgError}
            />

                <div style={{ paddingRight: "12px" }} className={classes.infoOuter}>
                    <Typography color='textSecondary' style={{textAlign: "justify"}}
                        dangerouslySetInnerHTML={{ __html: this.props.data.info }}>
                    </Typography>
                </div>

                <Typography
                    color="primary"  variant='body1'
                    style={{ marginTop: '10px', color: color }}
                >
                    <b>{this.props.data.cena + ' zł'}</b>
                </Typography> */}

                {/* <Grid container spacing={2} className={classes.gridContainer}>
                    <Grid item xs={12} style={{ display: "flex" }}>
                        <Grid
                            item //xs={12} sm={10} className={classes.grid3}
                            //style={{ height: '100%', width: '100%' }}
                            style={{ width: "calc(100% + -65px)" }}
                        >
                            <div style={{ paddingRight: "12px" }} className={classes.infoOuter}>
                                <Typography color='textSecondary' className={classes.infoInner}
                                    dangerouslySetInnerHTML={{ __html: this.props.data.info }}>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid
                            item //xs={12} sm={2} className={classes.grid3}
                            //style={{ height: '100%', width: '100%' }}
                            style={{ width: "65px" }}
                        >
                            <CardActions
                                className={classes.actions}
                                style={{ height: "84px", padding: '0', textAlign: 'end' }}
                            >
                                <Typography
                                    color="primary" align='center' variant='body1'
                                    style={{ marginBottom: '20px' }}
                                >
                                    <b>{this.props.data.cena + ' zł'}</b>
                                </Typography>
            
                            </CardActions>
                        </Grid>
                    </Grid>
                </Grid> */}


<Card
              key={this.props.data.asort_id}
              elevation={0}
              //classes={{ root: classes.card }}
            >
              <Grid container spacing={2} className={classes.gridContainer}>
                <Grid
                  item xs={12} sm={7}  //xs={12} sm={4} 
                  className={classes.grid} style={{width: "calc(100% + -6px)", paddingBottom: 0}}
                
                >
                 
                  <img 

                    
                    className={classes.media}
                    style={{width: "calc(100% + -8px)"}}
                    onClick={this.props.openGalery}

                    title={this.props.data.asort_nazwa}
                    src={`https://vsc24.net/vscKelnerBook/image/${CONFIG.hotelID}/${this.props.data.asort_id}/th_foto.jpg`}
                    onError={this.ImgError}
                  />

                </Grid>
                <Grid
                  item xs={12} sm={5} style={{}}//xs={12} sm={8}
                  // style={{
                  //   width: "auto", paddingBottom: "0px", paddingLeft: "0px",
                  //   paddingRight: "52px"
                  // }}
                  className={classes.grid2}
                >
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom variant="h6" component="h6" color="primary"
                      className={classes.headline}
                      style={{...this.contentTheme, color: color}}
                    >
                      {this.props.data.asort_nazwa}
                    </Typography>
                    <hr />
                  </Grid>

                  
                  <Grid item xs={12} style={{ display: "flex" }}>
                    <Grid
                      item //xs={12} sm={10} className={classes.grid3}
                      //style={{ height: '100%', width: '100%' }}
                      style={{width: "calc(100% + -65px)"}}
                    >
                      <div style={{ paddingRight: "12px"}} className={classes.infoOuter}>
                        <Typography color='textSecondary' className={`${classes.infoInner} ${classes.lightGray}`}
                          dangerouslySetInnerHTML={{ __html: this.props.data.info }}>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid
                      item //xs={12} sm={2} className={classes.grid3}
                      //style={{ height: '100%', width: '100%' }}
                      style={{width: "65px"}}
                    >
                      <CardActions
                        className={classes.actions}
                        style={{ padding: '0', textAlign: 'end', width: "100%" }}
                      >
                        <Typography
                          color="primary" align='center' variant='body1'
                          style={{ marginBottom: '20px', width: "100%", paddingTop: "4px", ...this.contentTheme, color: color }}
                        >
                          <b>{this.props.data.cena + ' zł'}</b>
                        </Typography>
                        
                      </CardActions>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>




          
        </DialogContent >
        <DialogActions >


          <ThemeProvider theme={createTheme({
            palette: {
              primary: {
                main: `${color}`,
              },
            },
            typography: {
              fontSize: 10,
              fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
            },
            overrides: {
              MuiButton: {
                contained: {
                  padding: "5px 16px"
                },
                outlinedSizeSmall: {
                  padding: "3.28px 9px 3px"
                }
              },
            }
          })}>
            <Button onClick={() => this.props.close()} variant="outlined" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>Back</Trans></b>
            </Button>
            <Button onClick={() => AddItem(this.props.data)} variant="contained" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem", padding: "4px 10px" }}
            >
              {/* <b><Trans>Next</Trans></b> */}
              <AddShoppingCartIcon style={{ width: "1.3em", height: "1.3em" }} />
            </Button>
          </ThemeProvider>
         
        </DialogActions>
      </Dialog>

    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    maxWidth: "800px"
  },
  primary: {
    color: theme.palette.primary.main
  },
  secondary: {
    //color: theme.palette.secondary.main
    color: "#3a87ad"
  },
  error: {
    //color: theme.palette.secondary.main
    color: "#c00"
  },
  padding: {
    whiteSpace: "pre" as "pre"
  },
  hr: {
    marginTop: "10px",
    minWidth: "320px"

  },
  media: {
    //width: "calc(100% + -10px)",
    //maxWidth: "300px",
    maxWidth: "96%",
    height: "auto",
    aspectRatio: "240/140",
    maxHeight: "270px",
    //paddingTop: '56.25%', // 16:9
    margin: "1px 1px 8px 1px",
    //marginBottom: "8px",
    ////float: "left",
    border: "5px solid #fff",
    //overflow: "hidden",
    //position: "relative",
    //textAlign: "center",
    boxShadow: "2px 2px 3px 2px #e6e6e6",
    //float: "left" as "left", 
    //position: "relative" as "relative", 
    textAlign: "center" as "center",
    cursor: "pointer" as "pointer"
  },
  infoOuter: {
    //paddingLeft: "42px", 
    //paddingRight: "52px",
    paddingTop: "4px"
},
infoInner: {
    //overflow: "hidden", 
    //maxHeight: "120px", 
    textAlign: "justify" as "justify",
},

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError));